module.exports = __webpack_public_path__ + "img/Virgo.cee72f70.png";